/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { application_id } from '../models/application_id';
import type { application_type_name } from '../models/application_type_name';
import type { ApplicationFree } from '../models/ApplicationFree';
import type { ApplicationListReponse } from '../models/ApplicationListReponse';
import type { contract_id } from '../models/contract_id';
import type { PushSubscription } from '../models/PushSubscription';
import type { PushSubscriptionDelete } from '../models/PushSubscriptionDelete';
import type { ReplaySettings } from '../models/ReplaySettings';
import type { user_email } from '../models/user_email';
import type { user_id } from '../models/user_id';
import type { user_token } from '../models/user_token';
import type { UserAccountSettings } from '../models/UserAccountSettings';
import type { UserAlertEmailNotifications } from '../models/UserAlertEmailNotifications';
import type { UserApplicationContextListResponse } from '../models/UserApplicationContextListResponse';
import type { UserApplicationContextSwitchRequest } from '../models/UserApplicationContextSwitchRequest';
import type { UserBusCanChartFilters } from '../models/UserBusCanChartFilters';
import type { UserBusCanChartLayout } from '../models/UserBusCanChartLayout';
import type { UserBusCanCustomLabels } from '../models/UserBusCanCustomLabels';
import type { UserBusCanPins } from '../models/UserBusCanPins';
import type { UserBusCanThresholds } from '../models/UserBusCanThresholds';
import type { UserBusCanValueTimeout } from '../models/UserBusCanValueTimeout';
import type { UserForList } from '../models/UserForList';
import type { UserForNew } from '../models/UserForNew';
import type { UserForUpdate } from '../models/UserForUpdate';
import type { UserGetJwtTokenResponse } from '../models/UserGetJwtTokenResponse';
import type { UserListParams } from '../models/UserListParams';
import type { UserListReponse } from '../models/UserListReponse';
import type { UserLogin } from '../models/UserLogin';
import type { UserLoginResponse } from '../models/UserLoginResponse';
import type { UserLostLogin } from '../models/UserLostLogin';
import type { UserLostPassword } from '../models/UserLostPassword';
import type { UserResetPassword } from '../models/UserResetPassword';
import type { UserTokenInfo } from '../models/UserTokenInfo';
import type { UserVodEmailNotifications } from '../models/UserVodEmailNotifications';
import type { VodFolder } from '../models/VodFolder';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UsersService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any Successful operation
     * @throws ApiError
     */
    public listVodFolders({
        contractId,
    }: {
        contractId: number,
    }): CancelablePromise<{
        items: Array<VodFolder>;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/vod-folders',
            query: {
                'contract_id': contractId,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns VodFolder Successful operation
     * @throws ApiError
     */
    public createVodFolder({
        requestBody,
    }: {
        requestBody: {
            contract_id: number;
            name: string;
        },
    }): CancelablePromise<VodFolder> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/vod-folders',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns VodFolder Successful operation
     * @throws ApiError
     */
    public renameVodFolder({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            name: string;
        },
    }): CancelablePromise<VodFolder> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/vod-folders/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public deleteVodFolder({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/vod-folders/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public addVodsToFolder({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            vod_ids: Array<number>;
        },
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/vod-folders/{id}/vods',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public removeVodsFromFolder({
        id,
        requestBody,
    }: {
        id: number,
        requestBody: {
            vod_ids: Array<number>;
        },
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/vod-folders/{id}/vods',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns ReplaySettings Successful operation
     * @throws ApiError
     */
    public getReplaySettings({
        contractId,
    }: {
        contractId: number,
    }): CancelablePromise<ReplaySettings> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/replay',
            query: {
                'contract_id': contractId,
            },
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * @returns ReplaySettings Successful operation
     * @throws ApiError
     */
    public saveReplaySettings({
        contractId,
        requestBody,
    }: {
        contractId: number,
        requestBody: ReplaySettings,
    }): CancelablePromise<ReplaySettings> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/replay',
            query: {
                'contract_id': contractId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Authentication required`,
                403: `Insufficient rights`,
                404: `Resource not found`,
                409: `Duplicate folder name`,
                415: `JSON required`,
            },
        });
    }
    /**
     * Create a new User
     * Creates a new User. (Access: admin)
     * @returns any Unexpected error
     * @returns UserForUpdate User created. The URI of the new resource is included in the Location header of the response.
     * @throws ApiError
     */
    public createUser({
        requestBody,
    }: {
        /**
         * User's information
         */
        requestBody: UserForNew,
    }): CancelablePromise<{
        code: number;
        message: string;
    } | UserForUpdate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Register as a new user of a contract and app
     * Creates a new User. (Access: free)
     * @returns any Unexpected error
     * @returns UserForUpdate User created. The URI of the new resource is included in the Location header of the response.
     * @throws ApiError
     */
    public registerUserForContractAndApp({
        requestBody,
    }: {
        /**
         * User's information
         */
        requestBody: {
            contract_id: contract_id;
            application_id: application_id;
            user_email: user_email;
            application_type_name?: application_type_name;
        },
    }): CancelablePromise<{
        code: number;
        message: string;
    } | UserForUpdate> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/register',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get a list of Users
     * Get a list of Users. (Access: admin)
     * @returns UserListReponse Users list
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUsers({
        requestBody,
    }: {
        /**
         * User's information
         */
        requestBody: UserListParams,
    }): CancelablePromise<UserListReponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/list',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a list application free for Users
     * Get a list application free for Users. (Access: admin)
     * @returns ApplicationListReponse Return list application free for User
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getApplicationsFree({
        requestBody,
    }: {
        /**
         * Userid and Contractid information
         */
        requestBody: ApplicationFree,
    }): CancelablePromise<ApplicationListReponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/listapplicationfree',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a User
     * Returns a User based on a single ID (Access: admin)
     * @returns UserForList User's information
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserById({
        id,
    }: {
        /**
         * ID of the User to fetch
         */
        id: user_id,
    }): CancelablePromise<UserForList | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update a User
     * Update a User. (Access: admin)
     * @returns UserForUpdate User updated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUser({
        id,
        requestBody,
    }: {
        /**
         * ID of the User to update
         */
        id: user_id,
        /**
         * User's information
         */
        requestBody: UserForUpdate,
    }): CancelablePromise<UserForUpdate | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Conflict`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete a user
     * Deletes a single User based on the ID supplied. (Access: admin)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deleteUserById({
        id,
    }: {
        /**
         * ID of the User to delete
         */
        id: user_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Get a new JWT token
     * Extend the session of the user by generating a new JWT-Token. (Access: all)
     * @returns UserGetJwtTokenResponse New token generated.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getNewJwtToken(): CancelablePromise<UserGetJwtTokenResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/jwt-token',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * List the authenticated user application contexts
     * Lists the non-expired application contexts available to the authenticated user for the current application type. (Access: all authenticated users)
     * @returns UserApplicationContextListResponse Available user application contexts.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserApplicationContexts(): CancelablePromise<UserApplicationContextListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/contexts',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Get the authenticated user's account settings
     * Returns all settings displayed by the player account page in one response.
     * @returns UserAccountSettings Account settings.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserAccountSettings(): CancelablePromise<UserAccountSettings | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/account-settings',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Switch the authenticated user application context
     * Issues a JWT for another non-expired application context belonging to the authenticated user and current application type. (Access: all authenticated users)
     * @returns UserLoginResponse User application context switched.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public switchUserApplicationContext({
        requestBody,
    }: {
        requestBody: UserApplicationContextSwitchRequest,
    }): CancelablePromise<UserLoginResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/context',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user's new VOD email notification preference
     * @returns UserVodEmailNotifications New VOD email notification preference.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserVodEmailNotifications(): CancelablePromise<UserVodEmailNotifications | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/vod-email-notifications',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Update the authenticated user's new VOD email notification preference
     * @returns UserVodEmailNotifications Updated new VOD email notification preference.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserVodEmailNotifications({
        requestBody,
    }: {
        requestBody: UserVodEmailNotifications,
    }): CancelablePromise<UserVodEmailNotifications | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/vod-email-notifications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user's alert email notification preference
     * @returns UserAlertEmailNotifications Alert email notification preference.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserAlertEmailNotifications(): CancelablePromise<UserAlertEmailNotifications | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/alert-email-notifications',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Update the authenticated user's alert email notification preference
     * @returns UserAlertEmailNotifications Updated alert email notification preference.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserAlertEmailNotifications({
        requestBody,
    }: {
        requestBody: UserAlertEmailNotifications,
    }): CancelablePromise<UserAlertEmailNotifications | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/alert-email-notifications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user's pinned Bus CAN keys
     * Returns the account-wide ordered Bus CAN keys pinned by the authenticated user.
     * @returns UserBusCanPins Ordered pinned Bus CAN keys.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserBusCanPins(): CancelablePromise<UserBusCanPins | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-pins',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Replace the authenticated user's pinned Bus CAN keys
     * Persists the supplied account-wide Bus CAN keys in their requested display order.
     * @returns UserBusCanPins Persisted ordered pinned Bus CAN keys.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserBusCanPins({
        requestBody,
    }: {
        requestBody: UserBusCanPins,
    }): CancelablePromise<UserBusCanPins | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-pins',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user Bus CAN thresholds
     * Returns the account-wide numeric alert thresholds configured by the authenticated user.
     * @returns UserBusCanThresholds Bus CAN thresholds by key.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserBusCanThresholds(): CancelablePromise<UserBusCanThresholds | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-thresholds',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Replace the authenticated user Bus CAN thresholds
     * Persists the supplied account-wide numeric alert thresholds by Bus CAN key.
     * @returns UserBusCanThresholds Persisted Bus CAN thresholds.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserBusCanThresholds({
        requestBody,
    }: {
        requestBody: UserBusCanThresholds,
    }): CancelablePromise<UserBusCanThresholds | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-thresholds',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user's Bus CAN chart filters
     * Returns account-wide chart display filters, indexed by canonical parameter identifier and shared across VODs. These filters are separate from alert thresholds.
     * @returns UserBusCanChartFilters Bus CAN chart filters by parameter identifier. An empty object means no filtering.
     * @throws ApiError
     */
    public getUserBusCanChartFilters(): CancelablePromise<UserBusCanChartFilters> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-chart-filters',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Replace the authenticated user's Bus CAN chart filters
     * Replaces all account-wide chart filters. Omitted keys lose their filter; {} clears all filters. Each entry must contain at least one finite numeric bound and min must be less than or equal to max. Bounds are inclusive. Values outside the range are omitted from chart drawing and axis scaling, leaving gaps without interpolation or modification of recorded data. Keys are canonical lower-case parameter identifiers (1 to 128 letters, digits or underscores, starting with a letter), independent of VOD availability.
     * @returns UserBusCanChartFilters Persisted Bus CAN chart filters.
     * @throws ApiError
     */
    public updateUserBusCanChartFilters({
        requestBody,
    }: {
        requestBody: UserBusCanChartFilters,
    }): CancelablePromise<UserBusCanChartFilters> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-chart-filters',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                415: `Unsupported Media Type`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get the authenticated user's Bus CAN chart layout
     * Returns the account-wide order and visibility of telemetry parameters and charts, shared across all VODs. Entries use the standard long_key returned by the cluster-manager fields route, not its technical sample key. Entries for parameters absent from the current VOD remain stored.
     * @returns UserBusCanChartLayout Ordered chart layout. An empty array means no saved layout.
     * @throws ApiError
     */
    public getUserBusCanChartLayout(): CancelablePromise<UserBusCanChartLayout> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-chart-layout',
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Replace the authenticated user's Bus CAN chart layout
     * Replaces the complete account-wide ordered list. Clients must retain entries for parameters absent from the current VOD when updating other entries. Omitted entries lose their saved order and visibility; [] resets the layout without modifying chart min/max filters. Each standard parameter identifier must occur only once, including when visibility differs. Unknown identifiers are allowed because available parameters vary between VODs. Newly encountered parameters are appended by the client with visible=false.
     * @returns UserBusCanChartLayout Persisted chart layout, in the submitted order.
     * @throws ApiError
     */
    public updateUserBusCanChartLayout({
        requestBody,
    }: {
        requestBody: UserBusCanChartLayout,
    }): CancelablePromise<UserBusCanChartLayout> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-chart-layout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                415: `Unsupported Media Type`,
                500: `Unexpected error`,
            },
        });
    }
    /**
     * Get the authenticated user's custom Bus CAN labels
     * @returns UserBusCanCustomLabels Custom Bus CAN labels by key.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserBusCanCustomLabels(): CancelablePromise<UserBusCanCustomLabels | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-custom-labels',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Replace the authenticated user's custom Bus CAN labels
     * @returns UserBusCanCustomLabels Persisted custom Bus CAN labels.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserBusCanCustomLabels({
        requestBody,
    }: {
        requestBody: UserBusCanCustomLabels,
    }): CancelablePromise<UserBusCanCustomLabels | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-custom-labels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get the authenticated user's Bus CAN value timeout
     * @returns UserBusCanValueTimeout Bus CAN value timeout.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserBusCanValueTimeout(): CancelablePromise<UserBusCanValueTimeout | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/preferences/bus-can-value-timeout',
            errors: {
                401: `Access token is missing or invalid`,
            },
        });
    }
    /**
     * Update the authenticated user's Bus CAN value timeout
     * @returns UserBusCanValueTimeout Persisted Bus CAN value timeout.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public updateUserBusCanValueTimeout({
        requestBody,
    }: {
        requestBody: UserBusCanValueTimeout,
    }): CancelablePromise<UserBusCanValueTimeout | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/preferences/bus-can-value-timeout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Register the current mobile push subscription
     * @returns any Unexpected error
     * @throws ApiError
     */
    public upsertPushSubscription({
        requestBody,
    }: {
        requestBody: PushSubscription,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/users/push-subscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete the current mobile push subscription
     * @returns any Unexpected error
     * @throws ApiError
     */
    public deletePushSubscription({
        requestBody,
    }: {
        requestBody: PushSubscriptionDelete,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/users/push-subscription',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Log a User
     * Log a User. (Access: all)
     * @returns UserLoginResponse User logged.
     * @returns any Unexpected error
     * @throws ApiError
     */
    public logUser({
        requestBody,
    }: {
        /**
         * Login's information
         */
        requestBody: UserLogin,
    }): CancelablePromise<UserLoginResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/login',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                409: `Multiple application contexts are available for this login.`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Used to get the login(s) of the User
     * Send an email to the User that a contains a list of his/her logins with the associated contract's name . (Access: all)
     * @returns any Send an email to the User.
     * @throws ApiError
     */
    public lostloginUser({
        requestBody,
    }: {
        /**
         * Lost LoginPassword's information
         */
        requestBody: UserLostLogin,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/lostlogin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not found`,
                415: `Unsupported Media Type`,
                502: `Failed to send an email to the user`,
            },
        });
    }
    /**
     * Used to reinit the password of the User
     * Send an email to the User to reinit his/her password.The email contained a link to a web page that asks to input the new password (eg resetpasswordwebpageurl parameter). This web page will use the POST /users/resetpassword to reset the password. It will receive the security token as a query parameter. (Access: all)
     * @returns any Send an email to the User.
     * @throws ApiError
     */
    public lostpasswordUser({
        requestBody,
    }: {
        /**
         * Lost Password's information
         */
        requestBody: UserLostPassword,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/lostpassword',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not found`,
                415: `Unsupported Media Type`,
                502: `Failed to send an email to the user`,
            },
        });
    }
    /**
     * Reset the password of the User. An email is sent to the User to confirm that his/her password has been changed.
     * Reset the password of the user. (Access: all)
     * @returns any Password has been resetted. An email is sent to the User to confirm that his/her password has been changed.
     * @throws ApiError
     */
    public resetpasswordUser({
        requestBody,
    }: {
        /**
         * Token
         */
        requestBody: UserResetPassword,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/users/resetpassword',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                415: `Unsupported Media Type`,
                498: `Password reset token is invalid or has expired`,
                502: `Failed to send an email to the user`,
            },
        });
    }
    /**
     * Get the validity of the user's reset password token
     * Returns if the token is valid (Access: all)
     * @returns UserTokenInfo User's token info
     * @returns any Unexpected error
     * @throws ApiError
     */
    public getUserResetPasswordTokenValidity({
        token,
    }: {
        /**
         * token that you want to check
         */
        token: user_token,
    }): CancelablePromise<UserTokenInfo | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/users/resetpasswordvalidity/{token}',
            path: {
                'token': token,
            },
            errors: {
                404: `Not found`,
            },
        });
    }
}
